module.exports = __webpack_public_path__ + "static/media/bali-bombings-social-share-@2x.0a8bfb18.png";